import { render, staticRenderFns } from "./medicalFabric.vue?vue&type=template&id=530d3b7c&scoped=true&"
import script from "./medicalFabric.vue?vue&type=script&lang=js&"
export * from "./medicalFabric.vue?vue&type=script&lang=js&"
import style0 from "./medicalFabric.vue?vue&type=style&index=0&id=530d3b7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530d3b7c",
  null
  
)

export default component.exports